import { render, staticRenderFns } from "./goToPrivate.vue?vue&type=template&id=22269610&scoped=true&"
import script from "./goToPrivate.vue?vue&type=script&lang=js&"
export * from "./goToPrivate.vue?vue&type=script&lang=js&"
import style0 from "./goToPrivate.vue?vue&type=style&index=0&id=22269610&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22269610",
  null
  
)

export default component.exports